import { createAction, props } from '@ngrx/store';
import { ProjectInterfaceWithId } from '@sk/sk-interfaces';

export const loadProjects = createAction('[Projects] Load Projects');

export const loadProjectsSuccess = createAction(
  '[Projects] Load Projects Success',
  props<{ projects: ProjectInterfaceWithId[] }>()
);

export const loadProjectsFailure = createAction(
  '[Projects] Load Projects Failure',
  props<{ error: any }>()
);

// ADD Projects
export const addProject = createAction(
  '[Projects] add Project',
  props<{ project: ProjectInterfaceWithId }>()
);


export const addProjectSuccess = createAction(
  '[Projects] added Project with success',
  props<any>()
);

export const addProjectError = createAction(
  '[Projects] added Project failed',
  props<{ error: Error }>()
);


// REMOVE Project
export const removeProject = createAction(
  '[Projects] removed',
  props<{
    id: string,
  }>()
);

export const removeProjectSuccess = createAction(
  '[Projects] removed with success',
  props<any>()
);

export const removeProjectError = createAction(
  '[Projects] removed failed',
  props<{ error: Error }>()
);


// UPDATE Projects
export const updateProject = createAction(
  '[Projects] update',
  props<{
    id: string,
    changes: ProjectInterfaceWithId
  }>()
);


export const updateProjectSuccess = createAction(
  '[Projects] update success',
  props<any>()
);

export const updateProjectsError = createAction(
  '[Projects] update failed',
  props<{ error: Error }>()
);


// FIRESTORE ACTIONS

export const queryFireStoreProjects = createAction(
  '[Projects] query projects',
  props<any>()
);


export const queryFireStoreProjectsError = createAction(
  '[Projects] error at query projects',
  props<{ error: Error }>()
);


export const fromFireStoreAddProject = createAction(
  '[Projects] added by Firestore',
  props<{ project: ProjectInterfaceWithId }>()
);

export const fromFireStoreModifyProject = createAction(
  '[Projects] modified by Firestore',
  props<{ project: ProjectInterfaceWithId }>()
);


export const fromFireStoreRemoveProject = createAction(
  '[Projects] removed by Firestore',
  props<{
    id: string,
  }>()
);



